import { Button } from '@mui/material';
import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useStoreState } from 'easy-peasy';
import { Link, useNavigate } from 'react-router-dom';
import { activityTypes, statusEnum } from '../../../../../helper/constants.helper';
import SelfAssessmentButtons from './SelfAssessmentButtons';
import CourseButtons from './CourseButtons';
import MeetingButtons from './MeetingButtons';

const ActionButtons = ({ historyItem, missingMandatory, intakeTasks }) => {
  const user = useStoreState((state) => state.user);
  const navigate = useNavigate();

  const handleClick = () => {
    if (
      historyItem.type === activityTypes.SELF_ASSESSMENT &&
      historyItem.status === statusEnum.COMPLETED
    ) {
      const url = historyItem.report_url;
      window.open(url);
    } else if (
      historyItem.type === activityTypes.SELF_ASSESSMENT &&
      historyItem.status === statusEnum.INITIATED
    ) {
      const url = historyItem.assessment_url;
      window.open(url);
    } else if (
      historyItem.type === activityTypes.COURSE &&
      historyItem.status === statusEnum.COMPLETED
    ) {
      const url = historyItem.certificate_url;
      window.open(url);
    } else if (
      historyItem.type === activityTypes.COURSE &&
      historyItem.status === statusEnum.INITIATED
    ) {
      navigate(`/course/${historyItem.id}`);
    }
  };

  return (
    <>
      <SelfAssessmentButtons historyItem={historyItem} handleClick={handleClick} />
      <CourseButtons historyItem={historyItem} handleClick={handleClick} />
      <MeetingButtons historyItem={historyItem} />
      {intakeTasks ? (
        <Button
          fullWidth
          size="small"
          style={{
            justifyContent: 'flex-start',
            textAlign: 'left'
          }}
          endIcon={missingMandatory ? <WarningAmberIcon style={{ color: '#ff0000' }} /> : null}>
          <Link to={`${user.orgId}`}>Intake Tasks</Link>
        </Button>
      ) : null}
      {historyItem?.invoiceUrl && (
        <Button
          href={historyItem.invoiceUrl}
          target="_blank"
          color="primary"
          size="small"
          style={{
            justifyContent: 'flex-start',
            textAlign: 'left'
          }}>
          Invoice
        </Button>
      )}
    </>
  );
};

export default ActionButtons;
